// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q60W","label":"styles_label__2fM8B"};